module.exports = __webpack_public_path__ + "static/media/dundalk.b4550914.png";